module.exports = __webpack_public_path__ + "media/4.44838c1c.wav";